import { Calculations } from 'bam-node-evp/src/Utilities/RunCalculations.ts'
import React from 'react'

type PlayerStatsProps = {
    stats: Calculations
}
export default function PlayerStats({ stats }: PlayerStatsProps) {
    return (
        <>
            <br />
            <br />
            <div className="additional-info">
                <div className="additional-info-position">Additional Info</div>
            </div>
            <hr />
            <div className="stats">
                <div className="stats-box">
                    <div className="stats-title">Pitches</div>
                    <div className="stats-value">{stats.pitches}</div>
                </div>

                <div className="stats-box">
                    <div className="stats-title">PA</div>
                    <div className="stats-value">{stats.pa}</div>
                </div>
                <div className="stats-box">
                    <div className="stats-title">H</div>
                    <div className="stats-value">{stats.hits}</div>
                </div>
                <div className="stats-box">
                    <div className="stats-title">1B</div>
                    <div className="stats-value">{stats.single}</div>
                </div>
                <div className="stats-box">
                    <div className="stats-title">2B</div>
                    <div className="stats-value">{stats.double}</div>
                </div>
                <div className="stats-box">
                    <div className="stats-title">3B</div>
                    <div className="stats-value">{stats.triple}</div>
                </div>
                <div className="stats-box">
                    <div className="stats-title">HR</div>
                    <div className="stats-value">{stats.hr}</div>
                </div>
                <div className="stats-box">
                    <div className="stats-title">AVG</div>
                    <div className="stats-value">{stats.ba}</div>
                </div>
                <div className="stats-box">
                    <div className="stats-title">SO</div>
                    <div className="stats-value">{stats.so}</div>
                </div>
                <div className="stats-box">
                    <div className="stats-title">wOBA</div>
                    <div className="stats-value">{stats.woba}</div>
                </div>
                <div className="stats-box">
                    <div className="stats-title">K%</div>
                    <div className="stats-value">{stats.kPercent}</div>
                </div>

                <div className="stats-box">
                    <div className="stats-title">EV</div>
                    <div className="stats-value">{stats.avgExitVelocity}</div>
                </div>
                <div className="stats-box">
                    <div className="stats-title">LA</div>
                    <div className="stats-value">{stats.avgLaunchAngle}</div>
                </div>
            </div>
        </>
    )
}
